//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        show: Boolean
    },
    data(){
        return{
            building_id:'',
            from: ''
        }
    },
    methods: {
        back () {
            wx.navigateBack()
        }
    },
    mounted(){
        const { building_id, from } = this.$route.query
        this.building_id = building_id
        this.from = from
    }
}
